import React from 'react';
import Routes from './routes';
import { homepage } from '@constants/defaultValues';
import { IntlProvider } from 'react-intl';
import { BrowserRouter } from 'react-router-dom';
import { AppLocale } from './lang';
import App from './app/app';
import { useSelector } from 'react-redux';

export function Init() {
    const lang = useSelector((state) => state.commonReducer.lang);
    const currentAppLocale = (AppLocale)[lang];
    return (
        <IntlProvider locale={currentAppLocale ? currentAppLocale.locale : lang} messages={currentAppLocale ? currentAppLocale.messages : ''}>
            <BrowserRouter basename={homepage}>
                <App>
                    <Routes />
                </App>
            </BrowserRouter>
        </IntlProvider>);
}



// WEBPACK FOOTER //
// ./src/init.js